import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/app/partner/PartnerForm.tsx");
